import { useTranslation } from "react-i18next";
import { MonitoringRecordPreview } from "../../../types/interfaces/file/imports/monitoringRecords";
import { useFormStyles } from "../../../hooks";
import { 
  Box, 
  Grid2, 
  InputAdornment, 
  Paper, 
  TextField, 
  Typography 
} from "@mui/material";
import { formatTimestamp } from "../../../utils";

interface UploadMonitoringRecordFormProps {
  monitoringRecord: MonitoringRecordPreview;
  variableName: string;
  variableUnit: string;
}

export const UploadMonitoringRecordForm = ({ 
  monitoringRecord,
  variableName,
  variableUnit,
}: UploadMonitoringRecordFormProps) => {
  const { t } = useTranslation();
  const formStyles = useFormStyles(true);

  return (
    <Box>
      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <Paper sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" mb={2}>
              {t("captures.capture.monitoring.title")}
            </Typography>

            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("flow-tests.flow-test-measurement.measured-at")}
                  value={monitoringRecord.measuredAt ? formatTimestamp(monitoringRecord.measuredAt) : ""}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("flow-tests.flow-test-measurement.variable")}
                  value={variableName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.monitoring.value")}
                  value={monitoringRecord.value}
                  disabled
                  sx={{ ...formStyles }}
                  slotProps={{
                    input: {
                      startAdornment: monitoringRecord.flag
                        ? <InputAdornment position="start">{monitoringRecord.flag}</InputAdornment>
                        : undefined,
                      endAdornment: <InputAdornment position="end">{variableUnit}</InputAdornment>
                    },
                  }}
                />
              </Grid2>

              <Grid2 size={12}>
                <TextField
                  fullWidth
                  label={t("captures.capture.monitoring.notes")}
                  value={monitoringRecord.notes ?? ""}
                  disabled
                  multiline
                  minRows={3}
                  sx={{ ...formStyles }}
                />
              </Grid2>
            </Grid2>
          </Paper>
        </Grid2>
      </Grid2>
    </Box>
  );
};